<script>
  export let title;
  export let isSwapped;

  let w;
</script>

<p class="invisible-text {isSwapped ? 'swapped' : ''} ">
  <span bind:offsetWidth={w}>
    {@html title}
  </span>
</p>
<p class={isSwapped ? "swapped" : ""} style="width: {w + 25}px;">
  {@html title}
</p>

<style>
  p {
    max-width: 300px;
    font-family: var(--font-big);
    font-size: 2.6rem;
    letter-spacing: 0.064rem;
    text-transform: uppercase;
    font-weight: 500;
    display: block;
    margin: auto 0;
    text-align: left;
    line-height: 1;
  }

  .invisible-text {
    visibility: hidden;
    position: absolute;
  }

  /* span {
    vertical-align: middle;
  } */

  /* TABLET */
  @media screen and (max-width: 767px) {
    p {
      font-size: 2.15rem;
    }
  }

  /* MOBILE */
  @media screen and (max-width: 567px), screen and (max-height: 567px) {
    p {
      font-size: 1.85rem;
    }
  }

  /* Incredibly tiny screens */
  @media screen and (max-width: 400px), screen and (max-height: 400px) {
    p {
      font-size: 1.7rem;
    }
  }
</style>
